import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eed94cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "send-notification"
}
const _hoisted_2 = { class: "send-notification__form form material-card_type_elevated" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "form__title" }, "Уведомление", -1))
const _hoisted_4 = { class: "form__field field" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "form__field field" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "form__field field"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__icon" }, null, -1))
const _hoisted_10 = { class: "send-notification" }

import messageCalloutIcon from '@/assets/icons/emojis/messageCallout.png';
import studentIcon from '@/assets/icons/emojis/student.png';
import ListSelect from '@/common/components/snedson-material-components/list-select/list-select.vue';
import TextField from '@/common/components/snedson-material-components/text-field/text-field.vue';
import customButton from '@/common/components/snedson-material-components/custom-button/custom-button.vue';
import { onMounted, reactive } from 'vue';
import { getSendNotificationPage, postSendNotifiation } from './api-methods';
import {
    NotificationForm,
    SendNotificationPageStateModel,
} from './send-notification-subpage.types';
import router from '@/router';
import { AxiosError } from 'axios';
import { EmptyResponse } from '@/models/EmptyResponse';


export default /*#__PURE__*/_defineComponent({
  __name: 'SendNotificationSubpage',
  setup(__props) {

const state = reactive<SendNotificationPageStateModel>(
    {} as SendNotificationPageStateModel
);

const onClassSelection = (schoolClassId: number | null) => {
    if (schoolClassId == null) {
        alert('Вы должны выбрать класс-получатель');
        return;
    }
    state.notification.groupId = null;
    state.notification.schoolClassId = schoolClassId;
};

const onGroupSelection = (groupId: number | null) => {
    state.notification.groupId = groupId;
};

const sendNotification = () => {
    if (!state.notification.text) {
        alert('Вы не указали текст уведомления');
        return;
    }

    if (!state.notification.schoolClassId) {
        alert('Вы не выбрали класс, которму придет уведомление');
        return;
    }

    postSendNotifiation({
        message: state.notification.text,
        recipientClassId: state.notification.schoolClassId,
        isAnnouncement: false,
        recipientGroupId: state.notification.groupId,
        recipientStudentId: null,
    })
        .then((response) => {
            console.log(response.data.errorTextForUser);
            router.push({ name: 'sn.teacher.notifications.forStudents' });
        })
        .catch((reason: AxiosError<EmptyResponse>) => {
            alert(reason.response?.data.errorTextForUser);
        });
};

onMounted(() => {
    getSendNotificationPage().then((response) => {
        state.notification = {} as NotificationForm;
        state.reponse = response.data;
    });
});

return (_ctx: any,_cache: any) => {
  return (state.reponse)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "field__icon",
              src: _unref(messageCalloutIcon)
            }, null, 8, _hoisted_5),
            _createVNode(TextField, {
              class: "field__input",
              placeholder: 'Введите текст уведомления',
              modelValue: state.notification.text,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.notification.text) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              class: "field__icon field__icon_margin-top",
              src: _unref(studentIcon)
            }, null, 8, _hoisted_7),
            _createVNode(ListSelect, {
              class: "field__input",
              props: {
                        title: 'Получатель: класс',
                        isDefaultSelectionAvaliable: true,
                        defaultSelectionTitle: 'Не выбрано',
                        selectedItemId: state.notification.schoolClassId,
                        menuItems: Object.entries(
                            state.reponse.schoolClasses
                        ).map(([id, title]) => ({ id: Number(id), title })),
                    },
              onSelected: onClassSelection
            }, null, 8, ["props"])
          ]),
          (state.notification.schoolClassId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(ListSelect, {
                  class: "field__input",
                  props: {
                        title: 'Получатель: группа класса',
                        isDefaultSelectionAvaliable: true,
                        defaultSelectionTitle: 'Весь класс',
                        selectedItemId: state.notification.groupId,
                        menuItems: Object.entries(
                            state.reponse.groupsByClasses[
                                state.notification.schoolClassId
                            ]
                        ).map(([id, title]) => ({ id: Number(id), title })),
                    },
                  onSelected: onGroupSelection
                }, null, 8, ["props"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(customButton, {
            props: {
                    iconName: 'send',
                    innerText: 'Отправить',
                    size: 'full',
                    type: 'filled',
                },
            onClick: sendNotification
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})